<template>
	<div class="layout">
		<div class="tool-box">
			<div class="tool-box-title">
				<img src="/static/imgs/qitadanju.png" class="jxyd-imgicon" />
				操作其它付款单
			</div>
			<button class="jxyd-button jxyd-primary" title="过账" @click="dataSubmitAndCheck"
				v-show="permission.isAudit && documentItem.checkState == 1">
				<Icon type="md-checkbox-outline" size='18' />
				过账
			</button>
			<button class="jxyd-button" title="回滚" @click="rollback([documentItem.id])"
				v-show="permission.isRollback && documentItem.id > 0 && documentItem.checkState > 1">
				<Icon type="md-sync" size='18'/>
				回滚
			</button>
			<button class="jxyd-button" title="保存" @click="dataSubmit"
				v-show="permission.isEdit && documentItem.checkState == 1">
				<Icon type="md-bookmark" size='18'/>
				保存
			</button>
			<button class="jxyd-button" title="打印" @click="printList" v-show="permission.isPrint">
				<Icon type="md-print" size='18' />
				打印
			</button>
		</div>
		<div>
			<div class="baseInfo">
				<div class="modal-title">
					<div class="layout-title-left">
						<img src="/static/imgs/jibenxinxi.png" class="jxyd-imgicon"/>
						基本信息
					</div>
					<div class="layout-title-right">
					</div>
				</div>

				<table class="baseinfo-table">
					<tr>
						<td class="key">
							单据编号
							<font color="red" style="position:relative; top:5px;font-weight:bold;font-size: 20px">*
							</font>
						</td>
						<td style="width:35%;">
							<input readonly="readonly" v-model="documentItem.code" type="text" placeholder="请输入单据编号"
								class="baseinfo-input" />
						</td>
						<td class="key">
							业务日期
							<font color="red" style="position:relative; top:5px;font-weight:bold;font-size: 20px">*
							</font>
						</td>
						<td style="width:35%;">
							<input v-model="documentItem.businessDate" type="date" placeholder="请选择业务日期"
								class="baseinfo-input" />
						</td>
					</tr>
					<tr>
						<td class="key">
							业务员
							<font color="red" style="position:relative; top:5px;font-weight:bold;font-size: 20px">*
							</font>
						</td>
						<td class="selectBox">
							<Select v-model="documentItem.userId" filterable clearable>
								<Option v-for="item in userList" placeholder="请选择业务员" :value="item.id" :key="item.id">
									{{item.userDisplayName}}
								</Option>
							</Select>
						</td>
						<td class="key">
						    收款人
						    <font color="red" style="position:relative; top:5px;font-weight:bold;font-size: 20px">*</font>
						</td>
						<td class="selectBox">
						    <Select v-model="documentItem.payee"
						            filterable clearable>
						        <Option v-for="item in payeeList"
						                placeholder="请选择收款人"
						                :value="item.name"
						                :key="item.id+item.name">
						            {{item.name}}
						        </Option>
						    </Select>
						</td>
					</tr>
					<tr>
						<td class="key">
							备注
						</td>
						<td style="text-align: left;">
							<input type="textarea" v-model="documentItem.note" placeholder="请输入备注"
								class="baseinfo-input">
						</td>
					</tr>
				</table>
			</div>
			<div class="commodityInfo">
				<div class="modal-title">
					<div class="layout-title-left">
						<img src="/static/imgs/feiyong.png" class="jxyd-imgicon"/>
						费用信息
					</div>
					<div class="layout-title-right">
					</div>
				</div>
				<Table stripe :columns="otherCostDetailColumn" :data="documentItem.otherCostDetailLists"></Table>
			</div>
			<div class="file">
				<div class="modal-title" style="border-bottom: 1px solid #e8eaec;">
					<div class="layout-title-left">
						<Icon type="ios-link" size='20' color='#bd10e0'/>
						单据附件
					</div>
					<div class="layout-title-right">
					</div>
				</div>
				<div style="padding:15px 10px;">
					<DocumentFile :isShow='false' :fileList.sync='documentItem.fileList'
						:actionPath='"/file/file/UploadFile"'></DocumentFile>
				</div>
			</div>
			<div id="voucher-bottomBar">
				<table style="float: left;">
					<tr>
						<td style="border-right:1px solid #DCDFE6;padding-right:15px;">
							<span style="font-size: 16px;font-weight: bold;color: var(--font1Color);">合计：</span>
							<span style="color: #ff4d4d;font-size: 22px;">￥{{documentItem.amount}}</span>
						</td>
						<td style="font-size: 16px;font-weight: bold;color: var(--font1Color);padding-left:15px;">定金：
						</td>
						<td>
							<SelectTradeMethod :value.sync='documentItem.payWay' :accountPid='accountPid'>
							</SelectTradeMethod>
						</td>
						<td style="padding-left: 5px;">
							<InputNumber v-model="documentItem.payAmount" :min="0" placeholder="定金"
								@on-change="!documentItem.payAmount ? documentItem.payAmount = 0 : documentItem.payAmount = documentItem.payAmount">
							</InputNumber>
						</td>
					</tr>
				</table>
			</div>
            <Modal v-model="costTypeConfigModal" draggable sticky scrollable>
                <p slot="header" style="text-align:left">
                    <Icon type="ios-create-outline" size='18'/>
                    <span> 添加选项</span>
                </p>
                <div style="width:100%;padding:5px;background-color:#fff;border-radius:5px;height:300px;overflow:auto;">
                    <table style="width:100%;">
                        <tr>
                            <td style="width:50%;">
                                <Input v-model="dictionaryFormItem.key" placeholder="请输入显示名" />
                            </td>
                            <td style="width:50%;" colspan="2">
                                <Input v-model="dictionaryFormItem.value" placeholder="请输入编号" @keyup.enter.native="addCostType()" />
                            </td>
                        </tr>
                        <tr>
                            <td class="tab-hander">显示名</td>
                            <td class="tab-hander">编号</td>
                            <td class="tab-hander" style="text-align:center;">操作</td>
                        </tr>
                        <tr v-for="item in costTypeList">
                            <td>{{item.key}}</td>
                            <td>{{item.value}}</td>
                            <td style="text-align:center;">
								<Icon type="md-trash" size='18' class="icon-item-dele" @click.stop="deleCostType(item.id)"/>
                            </td>
                        </tr>
                    </table>
                </div>
                <div slot="footer">
                    <Button size="large" type="error" @click="costTypeConfigModal = false;">关闭</Button>
                    <Button size="large" @click="addCostType()">保存</Button>
                </div>
            </Modal>
			<div class="billStateCls" v-show="documentItem.checkState == 2"><span>已过账</span></div>
			<div class="billStateCls" v-show="documentItem.checkState == 3"><span>已完结</span></div>
		</div>
	</div>
</template>

<script>
	import request from '@/utils/request'
	import formatNum from '@/utils/formatNum'
	import formatDate from '@/utils/formatDate'
	import dateUtil from '@/utils/dateUtil'
	import SelectTradeMethod from '@/components/SelectTradeMethod'
	import DocumentFile from '@/components/DocumentFile'
	export default {
		name: 'othercostlistfunc',
		components: {
			SelectTradeMethod,
			DocumentFile
		},
		data() {
			return {
				documentItem: {
					id: 0,
					code: '',
					businessDate: '',
					amount: 0,
					payAmount: 0,
					otherCostDetailLists: [],
					payee: '',
					discount: 100,
					userId: '',
					userName: '',
					creator: parseInt(localStorage.getItem("userId")),
					note: '',
					payWay: '',
					checkState: 1, //未过账
					fileList: []
				},
				otherCostDetailColumn: [{
						title: '行号',
						key: 'rowNum',
						width: 100
					},
					{
						title: '费用类别',
						key: 'costName',
						width: 220,
						render: (h, params) => {
							return [h('Select', {
									props: {
										transfer: true,
										value: params.row.costName
									},
									style: {
										width: '80%'
									},
									on: {
										input: (event) => {
											this.documentItem.otherCostDetailLists[params.index]
												.costName = event;
										}
									},
								},
								this.costTypeList.map(function(type) {
									return h('Option', {
										props: {
											value: type.key,
											key: type.key
										}
									}, type.key);
								})
							), h('Icon', {
                                style: {
                                    cursor: 'pointer',
                                },
								props:{
									type:"ios-settings-outline",
									size:24
								},
                                on: {
                                    click: (e) => {
                                        this.costTypeConfigModal = true;
                                    }
                                }
                            })];
						}
					},
					{
						title: '金额',
						key: 'costAmount',
						render: (h, params) => {
							return [h('InputNumber', {
								props: {
									min: 0,
									value: params.row.costAmount
								},
								style: {
									'width': '100%'
								},
								on: {
									input: (e) => {
										this.documentItem.otherCostDetailLists[params.index]
											.costAmount = e;
										this.$nextTick(function() {
											if (!this.documentItem.otherCostDetailLists[params
													.index].costName) {
												this.$Notice.error({
													title: '错误提示',
													duration: 3,
													desc: "费用类型不可为空！"
												});
												this.documentItem.otherCostDetailLists[params
													.index].costAmount = 0;
											}
										});

									}
								}
							})]
						}
					},
					{
						title: '备注',
						key: 'note',
						width: 500,
						render: (h, params) => {
							return [h('Input', {
								props: {
									min: 0,
									value: params.row.note
								},
								style: {
									'width': '100%'
								},
								on: {
									input: (e) => {
										this.documentItem.otherCostDetailLists[params.index].note = e;
									}
								}
							})]
						}
					},
					{
						title: '操作',
						key: 'action',
						align: 'center',
						render: (h, params) => {
							var btnArr = [];
							
							btnArr.push(h('Icon', {
							    style: {
							        cursor: 'pointer',
							        'margin-right': '10px'
							    },
								props:{
									type:'md-add-circle',
									size:24,
									color:'#ff6a7f'
								},
							    on: {
							        click: (e) => {
							           this.documentItem.otherCostDetailLists.push({
							           	rowNum: this.documentItem.otherCostDetailLists
							           		.length + 1,
							           	costName: '',
							           	costAmount: 0,
							           	note: '',
							           	creator: parseInt(localStorage.getItem(
							           		"userId"))
							           });
							        }
							    }
							}));
							btnArr.push(h('Icon', {
							    style: {
							        cursor: 'pointer',
							    },
								props:{
									type:'ios-remove-circle-outline',
									size:24
								},
							    on: {
							        click: (e) => {
							            if(this.documentItem.otherCostDetailLists.length <= 1){
							            	return;
							            }
							            this.documentItem.otherCostDetailLists.splice(params.index,
							            1);
							            for (var i = 0; i < this.documentItem.otherCostDetailLists
							            	.length; i++) {
							            	this.documentItem.otherCostDetailLists[i].rowNum = i + 1;
							            }
							        }
							    }
							}));
							
							return btnArr;
						}
					}
				],
				userList: [],
                payeeList: [],
                costTypePid:'fylb',
                costTypeList:[],
				permission: {
					isAdd: false,
					isEdit: false,
					isDelete: false,
					isAudit: false,
					isBatchAudit: false,
					isPrint: false,
					isRollback: false,
					isExport: false,
					isBatchPrint: false
				},
				accountPid: 'sfkzh',
                dictionaryFormItem: {
                    id: 0,
                    key: '',
                    value: '',
                    pid: 0,
					pcode:'',
                    creator: parseInt(localStorage.getItem("userId"))
                },
				costTypeConfigModal:false
			}
		},

		methods: {
			emptyForm() {
				this.documentItem.id = 0;
				this.documentItem.code = '';
				this.documentItem.businessDate = formatDate(dateUtil.getCurrentDate(), 'yyyy-MM-dd');
				this.documentItem.amount = 0;
				this.documentItem.otherCostDetailLists = [
				    {
				        rowNum: 1,
				        costName: '',
				        costAmount: 0,
				        note: '',
				        creator: parseInt(localStorage.getItem("userId"))
				    }
				];
				this.documentItem.payee = '';
				this.documentItem.discount = 100;
				this.documentItem.userId = parseInt(localStorage.getItem("userId"));
				this.documentItem.userName = '';
				this.documentItem.creator = parseInt(localStorage.getItem("userId"));
				this.documentItem.note = '';
				this.documentItem.payWay = '';
				this.documentItem.checkState = 1;
				this.documentItem.payAmount = 0;
				this.documentItem.fileList = [];
				this.getNextCode();
			},
			submitValidate() {
				if (!this.documentItem.code) {
				    this.$Notice.error({
				        title: '错误提示',duration: 3,
				        desc: "编号不可为空"
				    });
				    return false;
				}
				
				if (!this.documentItem.businessDate) {
				    this.$Notice.error({
				        title: '错误提示',duration: 3,
				        desc: "请选择业务日期"
				    });
				    return false;
				} else {
				}
				
				if (!this.documentItem.userId) {
				    this.$Notice.error({
				        title: '错误提示',duration: 3,
				        desc: "请选择业务员"
				    });
				    return false;
				}
				
				if (!this.documentItem.payee) {
				    this.$Notice.error({
				        title: '错误提示',duration: 3,
				        desc: "请选择收款人"
				    });
				    return false;
				}
				
				if (this.documentItem.note.length>50) {
				    this.$Notice.error({
				        title: '错误提示',duration: 3,
				        desc: "备注内容不得大于50字"
				    });
				    return false;
				}
				
				if (this.documentItem.amount <= 0) {
				    this.$Notice.error({
				        title: '错误提示',duration: 3,
				        desc: "您还没有添加费用"
				    });
				    return false;
				}
				
				if (this.documentItem.payAmount > this.documentItem.amount) {
				    this.$Notice.error({
				        title: '错误提示',duration: 3,
				        desc: "付款金额不得大于总金额"
				    });
				    return false;
				}
				for (var i = 0; i < this.documentItem.otherCostDetailLists.length; i++) {
				    if (this.documentItem.otherCostDetailLists[i].costName == "" || this.documentItem.otherCostDetailLists[i].costAmount == 0) {
				        this.$Notice.error({
				            title: '错误提示',duration: 3,
				            desc: "第"+(i+1)+"条费用类别或金额不可为空"
				        });
				        return;
				    }
				}
				return true;
			},
			dataSubmit() {
				var validate = this.submitValidate();
				if (!validate) {
					return;
				}
				let self = this;
				request.post('/api/OtherCostList/EditOtherCostList', self.documentItem).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: '保存失败:' + response.errorMsg
						});
						return;
					}

					//记录其它付款单操作
					var log = {
						FlowId: response.data,
						Title: '其它付款单日志',
						OperationContent: self.documentItem.id > 0 ? '编辑了此其它付款单' : '创建了此其它付款单',
						Operator: parseInt(localStorage.getItem("userId")),
						State: 1,
						Creator: parseInt(localStorage.getItem("userId"))
					}

					request.post('/api/ProcessLog/AddProcessLog', [log]).then(function(response) {
						if (response.data.state == 0) {
							self.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: '日志记录失败:' + response.data.errorMsg
							});
							return;
						}
					}).catch(function(error) {})

					//清空form规则检查
					self.emptyForm();
					self.$Notice.success({
						title: '正确提示',
						duration: 3,
						desc: '保存成功!'
					});


				}).catch(function(error) {})
			},
			dataSubmitAndCheck() {
				var validate = this.submitValidate();
				if (!validate) {
					return;
				}
				let self = this;
				request.post('/api/OtherCostList/EditOtherCostList', self.documentItem).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: '保存失败:' + response.errorMsg
						});
						return;
					}

					//记录其它付款单操作
					var log = {
						FlowId: response.data,
						Title: '其它付款单日志',
						OperationContent: self.documentItem.id > 0 ? '编辑了此其它付款单' : '创建了此其它付款单',
						Operator: parseInt(localStorage.getItem("userId")),
						State: 1,
						Creator: parseInt(localStorage.getItem("userId"))
					}
					request.post('/api/ProcessLog/AddProcessLog', [log]).then(function(response) {
						if (response.data.state == 0) {
							self.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: '日志记录失败:' + response.data.errorMsg
							});
							return;
						}
					}).catch(function(error) {})

					self.documentItem.id = response.data;
					self.checkOtherCostList([self.documentItem], 2, '其它付款单过账后不可更改，内容不可编辑，是否继续操作？');
				}).catch(function(error) {})
			},
			getNextCode() {
				let self = this;
				request.get('/api/OtherCostList/GetNextCode', {
					params: {
						prefix: 'QTF'
					}
				}).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取数据失败：" + response.errorMsg
						});
						return;
					}

					self.documentItem.code = response.data;
				}).catch(function(error) {})
			},
			rollback(ids) {
				if (ids.length < 1) {
					self.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "没有选中记录！"
					});
					return;
				}
				let self = this;
				this.$Modal.confirm({
					title: "操作警告",
					content: '是否回滚到过账流程？',
					onOk() {
						request.post('/api/OtherCostList/Rollback', ids).then(function(response) {
							if (response.state == 0) {
								self.$Notice.error({
									title: '错误提示',
									duration: 3,
									desc: "其它付款单回滚失败：" + response.errorMsg
								});
								return;
							}

							var log = [];
							for (var i = 0; i < ids.length; i++) {
								//记录采购单操作
								log.push({
									FlowId: ids[i],
									Title: '其它付款单日志',
									OperationContent: '回滚了此其它付款单',
									Operator: parseInt(localStorage.getItem("userId")),
									State: 1,
									Creator: parseInt(localStorage.getItem("userId"))
								});
							}
							request.post('/api/ProcessLog/AddProcessLog', log).then(function(response) {
								if (response.data.state == 0) {
									self.$Notice.error({
										title: '错误提示',
										duration: 3,
										desc: '日志记录失败:' + response.data.errorMsg
									});
									return;
								}
							}).catch(function(error) {})
							self.$Notice.success({
								title: '正确提示',
								duration: 3,
								desc: '回滚成功!'
							});
							self.getOtherCostList(ids[0]);
						}).catch(function(error) {})
					},
					onCancel() {}
				});
			},
			
			checkOtherCostList(objs, state, func) {
			    var self = this;
			    if (objs.length <= 0) {
			        self.$Notice.error({
			            title: '错误提示',duration: 3,
			            desc: "没有选中记录！"
			        });
			        return;
			    }
			    let stateObj = [];
			    let otherCostIds = [];
			    for (var i = 0; i < objs.length; i++) {
			        if (state == 2) {
			            if (objs[i].checkState != 1) {
			                self.$Notice.error({
			                    title: '错误提示',duration: 3,
			                    desc: "选中记录中包含不可过账的数据！"
			                });
			                return;
			            }
			
			            if (objs[i].payAmount < objs[i].amount) {
			                stateObj.push({
			                    id: objs[i].id,
			                    state: 2
			                });
			            } else {
			                stateObj.push({
			                    id: objs[i].id,
			                    state: 3
			                });
			            }
			            otherCostIds.push(objs[i].id);
			        }
			    }
			    this.$Modal.confirm({
			        title: "操作警告",
			        content: func,
			        onOk() {
			            request.post('/api/OtherCostList/CheckOtherCostList', stateObj).then(function (response) {
			
			                if (response.state == 0) {
			                    self.$Notice.error({
			                        title: '错误提示',duration: 3,
			                        desc: response.errorMsg
			                    });
			                    return;
			                }
			                let tag = '';
			                if (state == 1) {
			
			                } else if (state == 2) {
			                    tag = '过账';
			                }
			                var log = [];
			                for (var i = 0; i < otherCostIds.length; i++) {
			                    //记录采购单操作
			                    log.push({
			                        FlowId: otherCostIds[i],
			                        Title: '其它付款单日志',
			                        OperationContent: tag + '了此付款单',
			                        Operator: parseInt(localStorage.getItem("userId")),
			                        State: 1,
			                        Creator: parseInt(localStorage.getItem("userId"))
			                    });
			                }
			                request.post('/api/ProcessLog/AddProcessLog', log).then(function (response) {
			                    if (response.data.state == 0) {
			                        self.$Notice.error({
			                            title: '错误提示',duration: 3,
			                            desc: '日志记录失败:' + response.data.errorMsg
			                        });
			                        return;
			                    }
			                }).catch(function (error) {
			                })
			                self.$Notice.success({
			                    title: '正确提示',duration: 3,
			                    desc: tag + '成功!'
			                });
			                self.emptyForm();
			            }).catch(function (error) {
			            })
			        },
			        onCancel() {
			        }
			    });
			},
            countAmount(arr) {
                if (!this.documentItem.discount || this.documentItem.discount < 1 || this.documentItem.discount > 100) {
                    this.documentItem.discount = 100;
                }
                this.documentItem.amount = 0;
                for (let i = 0; i < arr.length; i++) {
                    this.documentItem.amount += arr[i].costAmount;
                }
                this.documentItem.amount = formatNum(this.documentItem.amount * (this.documentItem.discount / 100));
            },
			initUserToSelect() { //初始化用户下拉框数据源
				let self = this;
				request.get('/api/User/GetUserToSelect').then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取数据失败：" + response.errorMsg
						});
						return;
					}
					self.userList = response.data;
				}).catch(function(error) {})
			},
			initPermission() {
				let self = this;
				let params = {
					funcCodes: ['OtherCostList.Add', 'OtherCostList.Edit', 'OtherCostList.Delete',
						'OtherCostList.Audit', 'OtherCostList.BatchAudit', 'OtherCostList.Print',
						'OtherCostList.Rollback', 'OtherCostList.Export', 'OtherCostList.BatchPrint'
					],
					userId: parseInt(localStorage.getItem("userId"))
				};
				request.post('/api/Function/VerifyPermissions', params).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取权限数据失败：" + response.errorMsg
						});
						return;
					}
					for (var i = 0; i < response.data.length; i++) {
						switch (response.data[i].funcCode) {
							case 'OtherCostList.Add':
								self.permission.isAdd = response.data[i].permission
								break;
							case 'OtherCostList.Edit':
								self.permission.isEdit = response.data[i].permission
								break;
							case 'OtherCostList.Delete':
								self.permission.isDelete = response.data[i].permission
								break;
							case 'OtherCostList.Audit':
								self.permission.isAudit = response.data[i].permission
								break;
							case 'OtherCostList.BatchAudit':
								self.permission.isBatchAudit = response.data[i].permission
								break;
							case 'OtherCostList.Print':
								self.permission.isPrint = response.data[i].permission
								break;
							case 'OtherCostList.Rollback':
								self.permission.isRollback = response.data[i].permission
								break;
							case 'OtherCostList.Export':
								self.permission.isExport = response.data[i].permission
								break;
							case 'OtherCostList.BatchPrint':
								self.permission.isBatchPrint = response.data[i].permission
								break;
						}
					}
				}).catch(function(error) {})
			},
			printList() {
				this.packPrintData([this.documentItem]);
			},
			getOtherCostList(listId) {
				let self = this;
				request.get('/api/OtherCostList/GetOtherCostList', {
					params: {
						id: listId
					}
				}).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: response.errorMsg
						});
						return;
					}
					self.documentItem = response.data;
				}).catch(function(error) {})
			},
            initPayeeSelect() {
                let self = this;
                request.get('/api/Util/GetSupplierAndCustomer').then(function (response) {
                    if (response.state == 0) {
                        self.$Notice.error({
                            title: '错误提示',duration: 3,
                            desc: "获取收款人数据失败：" + response.errorMsg
                        });
                        return;
                    }
                    self.payeeList = response.data;
                }).catch(function (error) {
                })
            },
			initCostTypeOptionList() {
			    let self = this;
			    //获取收付款账户数据字典
			    return request.get('/api/DataDictionary/GetDataDictionaryList', {
			        params: {
			            code: this.costTypePid
			        }
			    }).then(function (response) {
			        if (response.state == 0) {
			            self.$Notice.error({
			                title: '错误提示',duration: 3,
			                desc: "获取收付款账户数据失败：" + response.errorMsg
			            });
			            return;
			        }
			        self.costTypeList = response.data;
			        return self.costTypeList[0].key;
			    }).catch(function (error) {
			    })
			    return "";
			},
            addCostType() {
                if (!this.dictionaryFormItem.key) {
                    this.$Notice.error({
                        title: '错误提示',duration: 3,
                        desc: '显示名不可为空!'
                    });
                    return;
                }
                if (!this.dictionaryFormItem.value) {
                    this.$Notice.error({
                        title: '错误提示',duration: 3,
                        desc: '编号不可为空!'
                    });
                    return;
                }

                if (this.dictionaryFormItem.key.length>20) {
                    this.$Notice.error({
                        title: '错误提示',duration: 3,
                        desc: '显示名输入内容不得大于20字!'
                    });
                    return;
                }
                if (this.dictionaryFormItem.value>20) {
                    this.$Notice.error({
                        title: '错误提示',duration: 3,
                        desc: '编号输入内容不得大于20字!'
                    });
                    return;
                }
                this.dictionaryFormItem.pcode = this.costTypePid;
                let self = this;
                request.post('/api/DataDictionary/AddDataDictionary', this.dictionaryFormItem).then(function (response) {
                    if (response.state == 0) {
                        self.$Notice.error({
                            title: '错误提示',duration: 3,
                            desc: '保存失败:' + response.errorMsg
                        });
                        return;
                    }
                    self.initCostTypeOptionList();
                    self.dictionaryFormItem.key = '';
                    self.dictionaryFormItem.value = '';
                    self.$Notice.success({
                        title: '正确提示',duration: 3,
                        desc: '保存成功!'
                    });

                }).catch(function (error) {
                })
            },
            deleCostType(id) {
                var self = this;
                request.post('/api/DataDictionary/DeleDataDictionary', [id]).then(function (response) {
                    if (response.state == 0) {
                        self.$Notice.error({
                            title: '错误提示',duration: 3,
                            desc: response.errorMsg
                        });
                        return;
                    }
                    self.initCostTypeOptionList();
                    self.$Notice.success({
                        title: '正确提示',duration: 3,
                        desc: '删除成功!'
                    });
                }).catch(function (error) {
                })
            },
			packPrintData(data) {
				data.forEach((item,index)=>{
					switch(item.checkState){
						case 1:
							item.checkState = '已创建'
						break;
						case 2:
							item.checkState = '已过账'
						break;
						case 3:
							item.checkState = '已完结'
						break;
					}
				})
				let selectedReceiptData = {
					name: 'otherCostList',
					title:'其它付款单',
					attributes: ['baseFieldItem', 'otherCostDetailLists'],
					receipts: data,
					baseFieldItem: [{
							name: 'code',
							displayName: '单据编号'
						},
						{
							name: 'userName',
							displayName: '业务员'
						},
						{
							name: 'businessDate',
							displayName: '业务日期'
						},
						{
							name: 'Payee',
							displayName: '收款人'
						},
						{
							name: 'amount',
							displayName: '应付金额'
						},
						{
							name: 'payAmount',
							displayName: '支付金额'
						},
						{
							name: 'checkState',
							displayName: '单据状态'
						},
						{
							name: 'note',
							displayName: '备注'
						}
					],
					otherCostDetailLists: [{
							name: 'costName',
							displayName: '费用名称'
						},
						{
							name: 'costAmount',
							displayName: '费用金额'
						},
						{
							name: 'note',
							displayName: '备注'
						},
						{
							name: 'createDate',
							displayName: '创建时间'
						}
					]
				}
				localStorage.setItem('_printData', JSON.stringify(selectedReceiptData));
				this.$router.push({
					path: 'printerpage'
				});
			}
		},
		watch: {
			'documentItem.otherCostDetailLists': {
				deep: true,
				handler(arr) {
					this.countAmount(arr);
				}
			},
			'$route.query.otherCostListId':{
				immediate: true,
				handler(param) {
					if(param){
						this.getOtherCostList(param);
					}else{
						this.emptyForm();
					}
				}
			}
		},
		created: function() {
			this.emptyForm();
			this.initPermission();
			this.initUserToSelect();
			this.initPayeeSelect();
			this.initCostTypeOptionList();
		}
	}
</script>

<style scoped>
	.layout {
		border-radius: 8px;
	}

	.tool-box {
		padding: 10px;
		background-color: #fff;
		overflow: hidden;
		border-left: 5px solid rgb(255, 106, 127);
		margin-bottom: 10px;
	}

	.tool-box Button {
		margin-left: 10px;
		float: right;
	}

	.tool-box-title {
		float: left;
		font-size: 16px;
		color: black;
		height: 30px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.baseInfo {
		background-color: #fff;
		border-radius: 5px;
		padding: 10px 10px;
	}

	.baseinfo-table {
		width: 100%;
		background-color: #fff;
		color: #666;
		border-collapse: collapse;
	}

	.baseinfo-table td,
	.baseinfo-table th {
		position: relative;
		padding: 9px 15px;
		min-height: 20px;
		line-height: 20px;
		font-size: 14px;
		border-width: 1px;
		border-style: solid;
		border-color: #e6e6e6;
	}


	.baseinfo-input {
		border: none;
		outline: none;
		height: 15px;
		padding-left: 0px;
		width: 100%;
	}

	.commodityInfo {
		margin-top: 10px;
		background-color: #fff;
		border-radius: 5px;
		padding: 10px 10px;
	}

	.file {
		margin-top: 10px;
		background-color: #fff;
		border-radius: 5px;
		padding: 10px 10px;
	}

	#voucher-bottomBar {
		background-color: antiquewhite;
		padding: 7.5px 22px 0px 10px;
		box-shadow: 0 -1px 6pxrgba(0, 0, 0, .15);
		display: flex;
		justify-content: space-between;
		align-items: center;
		height: auto !important;
		padding: 12px 30px !important;
	}

	.modal-title {
		overflow: hidden;
		padding-bottom: 10px;
		font-size: 16px;
	}

	.layout-title-left {
		float: left;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.layout-title-right {
		float: right;
	}

	.selectBox /deep/ div {
		border: none !important;
	}

	.discount-label {
		display: inline-block;
		text-align: center;
		width: 29%;
	}

	.billStateCls {
		width: 100px;
		height: 50px;
		line-height: 50px;
		font-size: 16px;
		position: absolute;
		top: 100px;
		left: 200px;
		border: solid 2px red;
		color: red;
		font-weight: 600;
		-webkit-transform: rotate(-30deg);
		transform: rotate(-30deg);
		z-index: 19999;
	}
	
	/deep/ .ivu-table-cell{
		display: flex;
		justify-content: center;
		align-items: center;
	}
	
	.icon-item-dele {
		cursor: pointer;
	}

	.icon-item-dele:hover {
		transform: scale(1.3);
	}
</style>